import React, { useEffect, useRef, useState } from "react"
import s from "./Instructions.module.scss"
import cx from "classnames"

import ArrowJump from "assets/svg/arrow-jump.svg"
import ArrowUp from "assets/svg/arrow-up.svg"
// import BgImg from "assets/images/new-ui/instructions-bg.jpg"
// import FullBgImg from "assets/images/new-ui/full-blue-bg-2.jpg"
import BgImg from "assets/images/2024-ui/background-3.jpg"
import Glow from "assets/images/2024-ui/leaderboard-ambient-glow.png";
// import FullBgImg from "assets/images/newest-ui/full-blue-bg-2.png"
// import Gift from "assets/images/instructions-gifts.png"
import Gift from "assets/images/instructions-present.png"
import Rock from "assets/images/instructions-obstacles.png"
import Timer from "assets/images/instructions-timer.png"
import Icepatch from "assets/images/instructions-icepatch.png"
import Snowball from "assets/images/instructions-snowball.png"
import Star from "assets/images/instructions-star.png"
import Watch from "assets/images/newest-ui/instructions/instructions-watch.png"
import Headphones from "assets/images/newest-ui/instructions/instructions-headphones.png"
// import PowerUps from "assets/images/new-ui/instructions-powerups.png"
// import BackButton from "components/BackButton/BackButton"
import AudioManager from "scripts/util/AudioManager"

import Character from "scripts/util/Character"
import { useSelector } from "react-redux"
import useQuery from "hooks/useQuery";

const WATCH_SLIDES = [
  {
    en: {
      type: "controls",
      subtitle: "Controls",
      proceed: "Okay",
      characterImg: {
        src: require("assets/images/character-1-instructions.png").default,
        alt: "",
      },
      controls: "",
    },
    es: {
      type: "controls",
      subtitle: "Controles",
      proceed: "Está bien",
      characterImg: {
        src: require("assets/images/character-1-instructions.png").default,
        alt: "",
      },
      controls: "",
    }
  },
  {
    en: {
      type: "objectives",
      subtitle: "Obstacles",
      proceed: "Got it",
      characterImg: {
        src: require("assets/images/character-1-instructions.png").default,
        alt: "",
      },
      controls: null,
    },
    es: {
      type: "objectives",
      subtitle: "Obstáculos",
      proceed: "Entendido",
      characterImg: {
        src: require("assets/images/character-1-instructions.png").default,
        alt: "",
      },
      controls: null,
    }
  },
  {
    en: {
      type: "objectives1",
      subtitle: "Power Ups",
      proceed: "Got it",
      characterImg: {
        src: require("assets/images/character-1-instructions.png").default,
        alt: "",
      },
      controls: null,
    },
    es: {
      type: "objectives1",
      subtitle: "Poderes",
      proceed: "Entendido",
      characterImg: {
        src: require("assets/images/character-1-instructions.png").default,
        alt: "",
      },
      controls: null,
    }
  },
  {
    en: {
      type: "objectives2",
      subtitle: "Power Ups",
      proceed: "Let's sled!",
      characterImg: {
        src: require("assets/images/character-1-instructions.png").default,
        alt: "",
      },
      controls: null,
    },
    es: {
      type: "objectives2",
      subtitle: "Poderes",
      proceed: "¡Vamos en trineo!",
      characterImg: {
        src: require("assets/images/character-1-instructions.png").default,
        alt: "",
      },
      controls: null,
    }
  },
]

Instructions.defaultProps = {}

const translate = {
  title: {
    en: "How to Play",
    es: "Cómo jugar",
  },
  swipeLeft: {
    line1: {
      en: "Swipe left",
      es: "Desliza a la izquierda",
    },
    line2: {
      en: "to move left",
      es: "para moverte hacia<br />la izquierda",
    }
  },
  swipeUp: {
    line1: {
      en: "Swipe up",
      es: "Desliza hacia arriba",
    },
    line2: {
      en: "to jump",
      es: "para saltar",
    }
  },
  swipeRight: {
    line1: {
      en: "Swipe right",
      es: "Desliza a la derecha",
    },
    line2: {
      en: "to move right",
      es: "para moverte <br />hacia la derecha",
    }
  },
  obstaclesText: {
    en: "Avoid obstacles and snowmen throwing&nbsp;snowballs!",
    es: "Evita los obstáculos y los <br />muñecos de nieve que lanzan <br />bolas de nieve."
  },
  plusUpsText: {
    en: "Collect power ups to gain <br />extra points or time.",
    es: "Recoge poderes para <br />ganar puntos o tiempo extra."
  },
  powerUpsText: {
    en: "Collect more power ups and extra <br />points with the snowball. Become<br /> invincible and earn double<br /> points with the star.",
    es: "Recoge más poderes y puntos <br />adicionales con las bolas de nieve. <br />Hazte invisible y gana doble <br />puntos con la estrella."
  },
  watchAgainText: {
    en: "Watch Again",
    es: "Ver otra vez"
  },
  skip: {
    en: "Skip",
    es: "Saltar",
  }
}

export default function Instructions({
  onComplete,
  showBackground = true,
  showReady = true,
  className = "",
}) {
  const lang = useQuery().get("lang") || "en";
  const character = useSelector((state) => state.game.character)
  const [slide, setSlide] = useState("watch")
  const [watchIndex, setWatchIndex] = useState(0)
  const [watchSlide, _setWatchSlide] = useState(WATCH_SLIDES[0][lang])
  const watchSlideRef = useRef(WATCH_SLIDES[0][lang])

  const setWatchSlide = (data) => {
    watchSlideRef.current = data
    _setWatchSlide(data)
  }

  useEffect(() => {
    if (watchIndex >= WATCH_SLIDES.length) {
      if (showReady) {
        setSlide("ready")
      } else {
        onComplete()
      }
    } else {
      setSlide("watch")
      setWatchSlide(WATCH_SLIDES[watchIndex][lang])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchIndex, showReady])

  const restartSlides = () => {
    setWatchIndex(0)
    setWatchSlide(WATCH_SLIDES[watchIndex][lang])
  }

  // const goBack = () => {
  //   AudioManager.playSound("uiSelect")
  //   // setWatchIndex(0)
  //   onComplete("back")
  // }

  const onPlay = () => {
    AudioManager.playSound("uiAccept")
    onComplete()
  }

  return (
    <div
      className={cx(s.Instructions, className, {
        [s.noBackground]: !showBackground,
      })}
    >
      <div
        className={cx(s.watch, {
          [s.show]: slide === "watch" && watchIndex < WATCH_SLIDES.length,
        })}
      >
        {showBackground && (
          <div className={s.background}>
            <img src={BgImg} alt="" className={s.bgFull} />
            <img src={Glow} alt="" className={s.bgFull} />
          </div>
        )}
        <div className={s.content}>
          <div className={s.contentInner}>
            <div className={s.mainCopy}>
              {/* <img className={s.howToPlay} src={HowToPlay} alt="How to Play" /> */}
              <h1 className={s.screenTitle} dangerouslySetInnerHTML={{__html: translate.title[lang]}}></h1>
              <h2 className={s.subtitle}>{watchSlide.subtitle}</h2>
              <div className={s.mainCopyInner}>
                <img
                  src={watchSlide.characterImg.src}
                  alt={watchSlide.characterImg.alt}
                  className={cx(s.character, s[watchSlide.type])}
                />
                <div
                  className={cx(s.flexWrapper, s.controls, {
                    [s.active]: watchSlide.type === "controls",
                  })}
                >
                  <div className={cx(s.controlsInner)}>
                    <div className={s.left}>
                      <img className={s.arrow} src={ArrowUp} alt="" />
                      <p>
                        {translate.swipeLeft.line1[lang]}
                        <span className={s.sub} dangerouslySetInnerHTML={{__html: translate.swipeLeft.line2[lang]}}></span>
                      </p>
                    </div>
                    <div className={s.up}>
                      <p>
                        {translate.swipeUp.line1[lang]}
                        <span className={s.sub} dangerouslySetInnerHTML={{__html: translate.swipeUp.line2[lang]}}></span>
                      </p>
                      <img className={s.arrow} src={ArrowJump} alt="" />
                    </div>
                    <div className={s.right}>
                      <img className={s.arrow} src={ArrowUp} alt="" />
                      <p>
                        {translate.swipeRight.line1[lang]}
                        <span className={s.sub} dangerouslySetInnerHTML={{__html: translate.swipeRight.line2[lang]}}></span>
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className={cx(s.objectivesWrapper, s.flexWrapper, {
                    [s.active]: watchSlide.type.indexOf("objectives") > -1,
                  })}
                >
                  <div
                    className={cx(s.flexWrapper, s.gift, {
                      [s.active]: watchSlide.type === "objectives",
                    })}
                  >
                    <p dangerouslySetInnerHTML={{__html: translate.obstaclesText[lang]}}></p>
                    <img
                      className={cx(s.itemImg, s.icepatchImg)}
                      src={Icepatch}
                      alt=""
                    />
                    <img
                      className={cx(s.itemImg, s.rockImg)}
                      src={Rock}
                      alt=""
                    />
                  </div>
                  <div
                    className={cx(s.flexWrapper, s.plusUps, {
                      [s.active]: watchSlide.type === "objectives1",
                    })}
                  >
                    <p dangerouslySetInnerHTML={{__html: translate.plusUpsText[lang]}}></p>
                    <img
                      className={cx(s.itemImg, s.giftImg)}
                      src={Gift}
                      alt=""
                    />
                    <img
                      className={cx(s.itemImg, s.timerImg)}
                      src={Timer}
                      alt=""
                    />
                    <img
                      className={cx(s.itemImg, s.watchImg)}
                      src={Watch}
                      alt=""
                    />
                    <img
                      className={cx(s.itemImg, s.headphonesImg)}
                      src={Headphones}
                      alt=""
                    />
                  </div>
                  <div
                    className={cx(s.flexWrapper, s.powerUps, {
                      [s.active]: watchSlide.type === "objectives2",
                    })}
                  >
                    <p dangerouslySetInnerHTML={{__html: translate.powerUpsText[lang]}}></p>
                    <img
                      className={cx(s.itemImg, s.snowballImg)}
                      src={Snowball}
                      alt=""
                    />
                    <img
                      className={cx(s.itemImg, s.starImg)}
                      src={Star}
                      alt=""
                    />
                  </div>
                  {/* <div
                    className={cx(s.flexWrapper, s.powerUps, {
                      [s.active]: watchSlide.type === "objectives3",
                    })}
                  >
                    <p>Use the Power-ups</p>
                    <img className={s.itemImg} src={PowerUps} alt="" />
                  </div> */}
                </div>
              </div>
            </div>
            <div className={s.nextWrapper}>
              {watchIndex < 3 ? (
                <button
                  className="btn md"
                  onClick={() => {
                    AudioManager.playSound("uiSelect")
                    setWatchIndex(watchIndex + 1)
                  }}
                >
                  {watchSlide.proceed}
                </button>
              ) : (
                <button
                  className="btn md"
                  onClick={() => {
                    AudioManager.playSound("uiSelect")
                    onPlay()
                  }}
                >
                  {watchSlide.proceed}
                </button>
              )}
              {watchIndex < 3 ? (
                <div
                  className={s.skip}
                  onClick={() => {
                    AudioManager.playSound("uiSelect")
                    // setWatchIndex(WATCH_SLIDES.length)
                    onPlay()
                  }}
                >
                  {translate.skip[lang]}
                </div>
              ) : (
                <div
                  className={s.skip}
                  onClick={() => {
                    AudioManager.playSound("uiSelect")
                    // setWatchIndex(WATCH_SLIDES.length)
                    restartSlides()
                  }}
                >
                  {translate.watchAgainText[lang]}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/*<div
        className={cx(s.ready, { [s.show]: slide === "ready" && showReady })}
      >
        <div className={s.background}>
          <img src={FullBgImg} alt="" className={s.bgFull} />
        </div>
        <div className={s.content}>
          {/* <img src={TitleImg} alt="" className={s.title} />
          <h1 className={s.screenTitle}>
            Ready <br /> to Sled?
          </h1>
          <div className={s.nextWrapper}>
            <img
              src={Character.getCharacter(character).img.src}
              alt=""
              className={cx(s.characterImg, s[character])}
            />
            <button className="btn md" id="play" onClick={onPlay}>
              Play
            </button>
          </div>
        </div>
      </div>
      {slide === "ready" && <BackButton onClick={goBack} />}
      */}
    </div>
  )
}
